import React, { useEffect, useState } from 'react';
import './Reviews.css';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';

const Reviews = () => {

    const [reviews, setReviews] = useState([]);
    const [user, setUser] = useState(null);

    const [rating, setRating] = useState(0);
    const [reviewText, setReviewText] = useState('');
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {

        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
        });

        return () => unsubscribe();

    }, []);

    useEffect(() => {

        fetch('https://badtameezdil-backend.onrender.com/reviews')
            .then((response) => response.json())
            .then((data) => {

                if (data.success) {
                    setReviews(data.reviews);
                }

            })
            .catch((error) => {
                console.log('Error fetching reviews:', error);
            });

    }, []);

    const submitReview = async () => {

        if (!user) {
            alert('Please login with Google to leave a review.');
            return;
        }

        if (rating === 0) {
            alert('Please select a rating.');
            return;
        }

        if (!reviewText.trim()) {
            alert('Please write a review.');
            return;
        }

        setSubmitting(true);

        try {

            const response = await fetch(
                'https://badtameezdil-backend.onrender.com/addreview',
                {
                    method: 'POST',

                    headers: {
                        'Content-Type': 'application/json'
                    },

                    body: JSON.stringify({
                        userId: user.uid,
                        userName: user.displayName || 'Customer',
                        rating: rating,
                        reviewText: reviewText.trim()
                    })
                }
            );

            const data = await response.json();

            if (data.success) {

                alert('Review submitted successfully!');

                setRating(0);
                setReviewText('');

                const reviewsResponse = await fetch(
                    'https://badtameezdil-backend.onrender.com/reviews'
                );

                const reviewsData = await reviewsResponse.json();

                if (reviewsData.success) {
                    setReviews(reviewsData.reviews);
                }

            } else {

                alert(data.message || 'Failed to submit review.');

            }

        } catch (error) {

            console.log('Error submitting review:', error);
            alert('Failed to submit review.');

        } finally {

            setSubmitting(false);

        }
    };

    return (
        <div className="reviews-page">

            <div className="reviews-header">

                <p className="reviews-small-title">
                    BADTAMEEZDIL GAMESTORE
                </p>

                <h1>Customer Reviews</h1>

                <p className="reviews-subtitle">
                    See what our customers have to say.
                </p>

            </div>

            <div className="reviews-container">

                <div className="write-review-card">

                    <h2>Write a Review</h2>

                    {user ? (

                        <>
                            <p className="logged-in-user">
                                Reviewing as <strong>{user.displayName}</strong>
                            </p>

                            <div className="rating-section">

                                <p>Your Rating</p>

                                <div className="rating-stars">

                                    {[1, 2, 3, 4, 5].map((star) => (

                                        <button
                                            key={star}
                                            type="button"
                                            className={star <= rating ? 'selected-star' : ''}
                                            onClick={() => setRating(star)}
                                        >
                                            ★
                                        </button>

                                    ))}

                                </div>

                            </div>

                            <textarea
                                className="review-input"
                                placeholder="Share your experience with BadtameezDil GameStore..."
                                value={reviewText}
                                onChange={(event) => setReviewText(event.target.value)}
                                maxLength={500}
                            />

                            <button
                                className="submit-review-button"
                                onClick={submitReview}
                                disabled={submitting}
                            >
                                {submitting ? 'Submitting...' : 'Submit Review'}
                            </button>
                        </>

                    ) : (

                        <div className="review-login-message">

                            <p>
                                Login with your Google account to write a review.
                            </p>

                            <a href="/login">
                                Login with Google
                            </a>

                        </div>

                    )}

                </div>

                {reviews.length === 0 ? (

                    <div className="no-reviews">

                        <h2>No reviews yet</h2>

                        <p>
                            Be the first customer to leave a review!
                        </p>

                    </div>

                ) : (

                    <div className="reviews-grid">

                        {reviews.map((review) => (

                            <div
                                className="review-card"
                                key={review._id}
                            >

                                <div className="review-card-top">

                                    <div className="review-user">

                                        <div className="review-avatar">
                                            {review.userName.charAt(0).toUpperCase()}
                                        </div>

                                        <div>

                                            <h3>{review.userName}</h3>

                                            <p>Verified Customer</p>

                                        </div>

                                    </div>

                                    <div className="review-stars">

                                        {'★'.repeat(review.rating)}
                                        {'☆'.repeat(5 - review.rating)}

                                    </div>

                                </div>

                                <p className="review-text">
                                    "{review.reviewText}"
                                </p>

                            </div>

                        ))}

                    </div>

                )}

            </div>

        </div>
    );
};

export default Reviews;